import { Button } from '@progress/kendo-react-buttons';
import React from 'react';
import { StackLayout } from '@progress/kendo-react-layout';
import { plusIcon } from '@progress/kendo-svg-icons';
import {
  useGlobalizationContext,
  useTranslation,
  useViewsContext,
  useCurrentUserContext,
  useGetViewsWritePermission
} from '@cs-cms/state-management';
import { DEFAULT_COLUMN_WIDTH } from '@cs-cms/types';

interface ViewHeaderButtonsProps {
  indexId?: number;
}

export const ViewHeaderButtons: React.FC<ViewHeaderButtonsProps> = ({ indexId }) => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);
  const { selectedViewData, editingViewState, setEditingViewState } = useViewsContext();
  const { selectedIndex } = useCurrentUserContext();
  const resolvedIndexId = indexId ?? selectedIndex?.id;
  const { data: hasWritePermission, isLoading: isWritePermissionLoading } =
    useGetViewsWritePermission(resolvedIndexId);

  const handleAddField = () => {
    if (!setEditingViewState) {
      return;
    }

    const newField = {
      id: 0,
      name: '',
      width: DEFAULT_COLUMN_WIDTH,
      facetsCount: undefined,
      isDocumentLink: false,
      isNew: true
    };

    setEditingViewState({
      ...editingViewState,
      fields: [newField, ...editingViewState.fields]
    });
  };

  const hasIncompleteFields = editingViewState.fields.some(field => !field.id);

  const isPrivateView = selectedViewData?.isPrivate ?? false;
  const canSaveView = isPrivateView || (!isWritePermissionLoading && hasWritePermission);

  const showAddFieldButton = selectedViewData && canSaveView;

  return (
    <>
      <StackLayout
        className="viewHeaderButtons"
        orientation={'horizontal'}
        align={{ horizontal: 'end', vertical: 'middle' }}
      >
        {showAddFieldButton && (
          <Button
            svgIcon={plusIcon}
            fillMode="flat"
            title={translate('custom.settings.views.private.addField')}
            onClick={handleAddField}
            disabled={hasIncompleteFields}
          >
            {translate('custom.settings.views.private.addField')}
          </Button>
        )}
      </StackLayout>
    </>
  );
};
